import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-login-error',
  templateUrl: './login-error.component.html',
  styleUrl: './login-error.component.scss',
  standalone: false,
})
export class LoginErrorComponent implements OnInit {
  errorMessage = '';
  // ============================================
  // Services
  // ============================================
  private readonly route = inject(ActivatedRoute);

  ngOnInit(): void {
    this.checkQueryParams();
  }

  // ============================================
  // Query Parameter Handling
  // ============================================

  /**
   * Check query parameters and set appropriate error message
   */
  private checkQueryParams(): void {
    this.route.queryParams.subscribe((params) => {
      const reason = params.reason || null;
      if (reason) {
        this.errorMessage = "You don't have permission to use this route.";
      } else {
        this.errorMessage = '';
      }
    });
  }
}
